import { render, staticRenderFns } from "./NoticeNotice.vue?vue&type=template&id=8eef1dfa"
import script from "./NoticeNotice.vue?vue&type=script&lang=js"
export * from "./NoticeNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports